import Container from '@mui/material/Container';
import { BrowserRouter } from "react-router-dom";
import HeaderSource from "./layout/HeaderSource";
import FooterSource from './layout/FooterSource';
import MainRouter from "./layout/MainRouter";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import citepayTheme from "./theme/citepayTheme";

function App() {

    return (
        <BrowserRouter>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={citepayTheme}>
                    <Container maxWidth={false} style={{padding: '0'}} sx={{display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%', margin: '0'}}>
                        <HeaderSource />
                        <Container maxWidth={false} style={{padding: '0 5vw .5rem 5vw'}}>
                            <MainRouter />
                        </Container>
                        <FooterSource/>
                    </Container>
                </ThemeProvider>
            </StyledEngineProvider>
        </BrowserRouter>
    );
}

export default App;
